export default "__VITE_ASSET__CkVeWLE6__"